/*
 * @Author: lc
 * @Date: 2022-09-24 11:22:45
 * @LastEditors: lc
 * @LastEditTime: 2022-10-09 08:58:20
 * @Description: 
 */
/**
  * 权限菜单 接口的统一出口
  */
import axios from '.././http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来


// 接口请求地址
const api = '/c-api/';

const datastream = {
    // 列表
    list (params) {
        return axios.get(api + 'datastream/list', { params: params })
    },
    // 删除
    remove (params) {
        return axios.post(api + 'datastream/remove', qs.stringify(params))
    },
    detail (params) {
        return axios.get(api + 'datastream/detail', { params: params })
    },
    //更新配置
    editset (params) {
        return axios.post(api + 'datastream/editset', qs.stringify(params))
    },
}


// 导出接口
export default datastream
